import { Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { MenuService } from '@awp/app-common';
import { isNullOrEmpty } from '@awp/core/utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../../../app-common/src/lib/menu.service";
var ThemeNoMenuGuard = /** @class */ (function () {
    function ThemeNoMenuGuard(router, menuService) {
        this.router = router;
        this.menuService = menuService;
    }
    ThemeNoMenuGuard.prototype.canActivate = function (route, state) {
        var themeId = route.paramMap.get('themeId');
        if (isNullOrEmpty(themeId)) {
            return this.router.createUrlTree(['page/not-found']);
        }
        var url = this.extractUrl(state.url);
        if (url.endsWith(themeId)) {
            return this.resolveMainMenu(themeId, route.queryParams);
        }
        else {
            return true;
        }
    };
    ThemeNoMenuGuard.prototype.canActivateChild = function (childRoute, state) {
        var themeId = childRoute.paramMap.get('themeId');
        var url = this.extractUrl(state.url);
        if (url.endsWith(themeId)) {
            return this.resolveMainMenu(themeId, childRoute.queryParams);
        }
        else {
            return true;
        }
    };
    ThemeNoMenuGuard.prototype.resolveMainMenu = function (themeId, queryParams) {
        var _this = this;
        return this.menuService.values
            .pipe(map(function (items) {
            var tree = _this.router.createUrlTree(['/', themeId, items[0].url], { replaceUrl: true, queryParams: queryParams });
            return tree;
        }), take(1));
    };
    ThemeNoMenuGuard.prototype.extractUrl = function (url) {
        if (url != null && url.includes('?')) {
            return url.substr(0, url.indexOf('?'));
        }
        return url;
    };
    ThemeNoMenuGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ThemeNoMenuGuard_Factory() { return new ThemeNoMenuGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.MENU_TOKEN)); }, token: ThemeNoMenuGuard, providedIn: "root" });
    return ThemeNoMenuGuard;
}());
export { ThemeNoMenuGuard };
